import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { Button, FormControl, InputLabel, MenuItem, Select, Checkbox, FormControlLabel } from '@material-ui/core';
import { handleChangeEvent, handlePost } from '../../../../utils/AxiosUtil';
import { toDateFormat } from '../../../../utils/Util';
import * as enums from '../../../../utils/EnumMapping';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareNumberField from '../../../common/inputfields/ErrorAwareNumberField';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import MyMultiSelectAutocomplete from '../../../common/inputfields/MyMultiSelectAutocomplete';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import * as util from './ProjectUtil';

class NewProject extends Component {

    state = {
        newAgain: false,
        selectedCustomers: [],
        publicId: '',
        location: '',
        paymentCommitmentInDays: '',
        startDate: new Date(),
        errors: new Map(),
        comment: '',
        shortName: '',
        firstTwoPhaseTogether: false,
        firstTwoPhaseTogetherVisible: false
    };

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedCustomers: [],
            publicId: '',
            location: '',
            paymentCommitmentInDays: '',
            startDate: new Date(),
            errors: new Map(),
            comment: '',
            shortName: '',
            firstTwoPhaseTogether: false,
            firstTwoPhaseTogetherVisible: false
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/project';
        const requestObject = {
            "customerIds": util.getCustomers(this.state.selectedCustomers),
            "publicId": this.state.publicId,
            "location": this.state.location,
            "paymentCommitmentInDays": this.state.paymentCommitmentInDays,
            "startDate": toDateFormat(this.state.startDate),
            "comment": this.state.comment,
            "shortName": this.state.shortName,
            "billingType": this.state.billingType.value,
            "firstTwoPhaseTogether": this.state.firstTwoPhaseTogether
        };
        await handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyMultiSelectAutocomplete
                            value={this.state.selectedCustomers}
                            getOptions={util.promiseCustomerOptions}
                            onChange={(e, v) => util.handleCustomerSelected(e, v, this)}
                            label={'Vevő'}
                            createLabel={'Új vevő'}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="publicId"
                            label="Munkaszám"
                            value={this.state.publicId}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="location"
                            label="Helyszín"
                            value={this.state.location}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="shortName"
                            label="Rövid név"
                            value={this.state.shortName}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <FormControl variant="outlined" fullWidth required>
                            <InputLabel id="billing-type-label">Számlázás gyakorisága</InputLabel>
                            <Select
                                name="billingType"
                                labelId="billing-type-label"
                                id={this.props.name}
                                value={this.state.billingType}
                                onChange={e => handleChangeEvent(e, this)}
                                label="Számlázás gyakorisága">
                                {enums.projectBillingTypes.map((value, index) =>
                                    <MenuItem key={index} value={value}>{value.label}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </div>
                    <div className='input-group'>
                        <ErrorAwareNumberField
                            required
                            name="paymentCommitmentInDays"
                            label="Fizetési határidő(napok száma)"
                            value={this.state.paymentCommitmentInDays}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            name="startDate"
                            label="Kezdés dátuma"
                            errors={this.state.errors}
                            value={this.state.startDate}
                            onChange={(value) => util.handleStartDateChanged(value, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        {(this.state.firstTwoPhaseTogetherVisible) &&
                            <FormControlLabel
                                value="firstTwoPhaseTogether"
                                control={<Checkbox color="primary" checked={this.state.firstTwoPhaseTogether} onChange={e => this.setState({ firstTwoPhaseTogether: e.target.checked })} />}
                                label="Első két ütem együtt"
                                // labelPlacement="start"
                                className="another-checkbox"
                            />}
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewProject);
